// extracted by mini-css-extract-plugin
module.exports = {"button":"MapMarker_button__Sxotg","active":"MapMarker_active__G2hQm","shadow":"MapMarker_shadow__phyl4"};